import { realtimeRefreshMs, realtimeLifetimeMs } from "../constants/realtime";
import { useEffect, useRef, useState } from "react";
import { connectRealtime, clearRealtime } from "../util/realtimeSession";
export function useRealtimeSession(userId, request) {
  const validUntil = useRef(0);
  const api = useRef(request); api.current = request;
  const token = localStorage.getItem("accessToken") || "";
  const identity = userId && token ? `${userId}:${token}` : "";
  const [snapshot, setSnapshot] = useState({});
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true;
    if (!identity) { clearRealtime(); return; }
    const connect = async () => {
      if (validUntil.current && Date.now() >= validUntil.current) setSnapshot({ identity, ready: false });
      try { const result = await connectRealtime((...args) => api.current(...args)); if (active) { validUntil.current = result?.validUntil || Date.now() + realtimeLifetimeMs; setSnapshot({ identity, ready: true }); } }
      catch { if (active) setSnapshot({ identity, error: true }); }
    };
    connect();
    const onVisible = () => { if (!document.hidden) connect(); };
    const timer = setInterval(onVisible, realtimeRefreshMs);
    document.addEventListener("visibilitychange", onVisible);
    return () => { active = false; clearInterval(timer); document.removeEventListener("visibilitychange", onVisible); };
  }, [identity, attempt]);
  return { ready: snapshot.identity === identity && snapshot.ready, error: snapshot.identity === identity && snapshot.error, retry: () => setAttempt(value => value + 1) };
}
